'use client'

import { ClientLink } from 'utils/link/client/ClientLink'

import { useCartUrl } from '../hooks/useCartUrl'

interface CartClientLinkProps {
	readonly id: string
	readonly className?: string
	readonly onClick?: () => void
	readonly linkProps?: Record<string, unknown>
	readonly children: React.ReactNode
}

export function CartClientLink({
	id,
	className,
	onClick,
	linkProps,
	children,
}: CartClientLinkProps): React.ReactNode {
	const url = useCartUrl()

	return (
		<ClientLink
			id={id}
			className={className}
			href={url.href}
			prefetch={false}
			onClick={onClick}
			linkProps={linkProps}
		>
			{children}
		</ClientLink>
	)
}
